import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';
import slideshow from './slideshow';

Router.get('judge/([a-zA-Z]+)', form);
Router.get('judge/([a-zA-Z]+)/slideshow', slideshow);
Router.get('judge', index);
